import React from 'react';
import { Box } from '@mui/material';
import { IContract } from '../../../../../../types/contract';
import {
  ContractExtractionResult,
  Paragraph,
} from '../../../../../../types/aiOutput';
import { DialogMode } from '../../../../../../types/dialogmode';
import { IPrompt } from '../../../../../../types/prompt';
import { IDocument } from '../../../../../../types/document';
import ContractSuggestedPromptAccordion from '../../ContractSuggestedPromptAccordion';

interface FieldsSuggestedTabProps {
  contract: IContract;
  suggestedPrompts: Partial<IPrompt & { relavantParagraphs: Paragraph[] }>[];
  mode: DialogMode;
  aiOutputs: ContractExtractionResult[];
  selectParagraph: (
    paragraph?: Paragraph,
    prompt?: IPrompt,
    aiOutput?: ContractExtractionResult
  ) => void;
  expanded?: string;
  documents: IDocument[];
}

const FieldsSuggestedTab: React.FC<FieldsSuggestedTabProps> = ({
  contract,
  suggestedPrompts,
  mode,
  aiOutputs,
  selectParagraph,
  expanded,
  documents,
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={5}>
      {suggestedPrompts?.map((suggestedPrompt) => {
        return (
          <ContractSuggestedPromptAccordion
            key={`contractSuggestedPromptAccordion-${suggestedPrompt.id}`}
            suggestedPrompt={suggestedPrompt as any}
            contract={contract}
            mode={mode}
            aiOutputs={aiOutputs}
            selectParagraph={selectParagraph}
            isExpanded={expanded === suggestedPrompt.id}
            infoFound={true}
            documents={documents}
          />
        );
      })}
    </Box>
  );
};

export default FieldsSuggestedTab;
